import React from 'react'
import ContactsBlock from '../contacts-block'
import { YMaps, Map, Placemark } from 'react-yandex-maps'
import {SellMoreScreen} from "~common/sell-more-screen";
import {Styled} from "~/components/pages/features/components/detail/admin/styled";
import {useAppSelector} from "~/hooks/redux";

const Contacts: React.FC = () => {
  const { country } = useAppSelector(state => state.countryReducer)

  const placeMark = {
    geometry: [56.836456, 60.591491],
    options: {
      iconLayout: 'default#image',
      iconImageHref: process.env.PUBLIC_DIR + '/images/placemark.svg',
      iconImageSize: [200, 200],
      iconImageOffset: [-35, -135]
    }
  }

  const placeMarkUZ = {
    geometry: [41.331562, 69.269029],
    options: {
      iconLayout: 'default#image',
      iconImageHref: process.env.PUBLIC_DIR + '/images/placemarkUZ.svg',
      iconImageSize: [200, 200],
      iconImageOffset: [-35, -135]
    }
  }

  return (
    <div className='onlinepbx__contacts'>
      <div className='onlinepbx__head'>
        <div className='onlinepbx__container'>
          <h2 className='onlinepbx__content__header__center'>Контакты</h2>
          <div className='onlinepbx__contacts__content'>
            <ContactsBlock />
          </div>
        </div>
        {country?.value !== 'KZ' &&
          <div>
            {country?.value === 'RU'
              ? <div>
                  <YMaps>
                    <Map width='100%' height='366px' defaultState={{ center: [56.836466, 60.591492], zoom: 18 }}>
                      <Placemark {...placeMark} />
                    </Map>
                  </YMaps>
                </div>
              : <YMaps>
                  <Map width='100%' height='366px' defaultState={{ center: [41.331562, 69.269029], zoom: 18 }}>
                    <Placemark {...placeMarkUZ} />
                  </Map>
                </YMaps>
            }
        </div>
        }
        <Styled.SelMore className="onlinepbx__sel__more">
          <SellMoreScreen />
        </Styled.SelMore>
      </div>
    </div>
  )
}

export default Contacts
